import React, { useEffect } from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { useRequest } from '../../api/hooks';
import { UserEndpoint } from '@/models/user';

export type Props = {
  userId: number;
  type: 'consume' | 'card' | 'order';
  fallback?: React.ReactNode;
  num?: number;
  version?: number;
};

const UserDomainCountAsync: React.FC<Props> = ({
  type,
  userId,
  version = 0,
  num: init,
  fallback,
}: Props) => {
  const { payload, send, loading, setPayload, loaded, error } = useRequest<number>(
    {},
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (userId && init === undefined) {
      send({
        url: `${UserEndpoint}/count/${type}`,
        params: { userId },
      }).then();
    }
  }, [userId, init, type, version]);

  useEffect(() => {
    if (init !== undefined) {
      setPayload(init);
    }
  }, [init]);

  if (loading) {
    return <SyncOutlined spin />;
  }

  if (error && fallback) {
    return <>{fallback}</>;
  }

  if (loaded) {
    return <>{payload}</>;
  }
  return <>...</>;
};

export default UserDomainCountAsync;
